/** The medallion of the referral program's gold, on its own so the profile
 *  menu, on every signed-in page, doesn't pull in the whole referrals view. */
export const GOLD_MEDALLION =
  "flex shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-yellow-300 via-amber-400 to-amber-600 text-white shadow-sm";
